import styled from "styled-components";

export const Header = styled.header`
  grid-area: header;

  align-items: center;
  display: flex;
  gap: 20px;
`;
